/**
 * Created by Andrey Popov on 07.06.2021
 */

const AvatarMenuBarItemModel = function (config) {
    MenuBarItem.call(this, config);

    this.onChangeLevelNo = function () {};
    this.onChangeExpProgress = function () {};
};

AvatarMenuBarItemModel.prototype = Object.create(MenuBarItem.prototype);
AvatarMenuBarItemModel.prototype.constructor = AvatarMenuBarItemModel;

AvatarMenuBarItemModel.prototype.withLevel = function () {
    return cleverapps.config.features.includes("game_level")
        && ["merge", "merge2", "farm"].includes(cleverapps.config.type);
};

AvatarMenuBarItemModel.prototype.getTargetTypes = function () {
    return this.withLevel() ? this.config.targets : undefined;
};

AvatarMenuBarItemModel.prototype.customInit = function () {
    if (!this.withLevel()) {
        return;
    }

    cleverapps.gameLevel.on("changeLevel", () => {
        this.onChangeLevelNo();
    }, this);
    cleverapps.exp.on("changeExp", () => {
        this.onChangeExpProgress();
    }, this);
};

AvatarMenuBarItemModel.prototype.debugAction = function () {
    const options = {
        event: cleverapps.EVENTS.EARN.OTHER
    };

    const reward = new Reward("exp", cleverapps.gameLevel.nextLevelThreshold(), options);
    reward.receiveReward();
    reward.collectRewardsAnimation(undefined, options);
};

AvatarMenuBarItemModel.prototype.getCurrentValue = function () {
    return {
        level: cleverapps.gameLevel.getLevel(),
        amount: cleverapps.exp.getExp(),
        total: cleverapps.gameLevel.nextLevelThreshold()
    };
};
